import { useTranslation } from 'react-i18next';
import { useAuth } from '~/services/auth';
import { useSyncUser } from '~/hooks/models/useUser';
import { LoadingPage } from '~/pages/LoadingPage';
import Infos from '~/pages/Auth/infos';

import { LinkButton } from '~/components/ui/link';
import { IoIosLogOut } from 'react-icons/io';

import { HomeContent } from './HomeContent';

export function Home() {
    const { t } = useTranslation();
    const { auth, logout } = useAuth();
    const user = useSyncUser(auth.uid);

    if (!user) {
        return <LoadingPage>{t('home.loadingData')}</LoadingPage>;
    }

    const siteIDs = user?.getSiteIDs();

    if (!siteIDs || siteIDs.length === 0) {
        return (
            <Infos userFlow={user.signupFlow}>
                <LinkButton
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        padding: 'var(--spacing-m)',
                    }}
                    onClick={logout}
                >
                    {t('home.logout')}
                    <IoIosLogOut style={{ verticalAlign: 'middle' }} size={24} />
                </LinkButton>
            </Infos>
        );
    }

    return <HomeContent clientIDs={siteIDs.filter((value) => value !== '*')} />;
}

export function HomeDemo() {
    return <HomeContent clientIDs={['demo']} />;
}
